import { ERP_OPENING_HOURS_CONFIG_STORAGE_KEY, LOGIN_EMAIL_STORAGE_KEY } from './account.constants'

//#region signupEmailStorage
/**
 * Functions to save/retrieve/clear the signup email in/from sessionStorage.
 * This is used to prefill the email field in the login form when inside the signup flow.
 */
export function saveSignupEmailToStorage(email: string): void {
  try {
    sessionStorage.setItem(LOGIN_EMAIL_STORAGE_KEY, email)
  } catch (e) {
    console.warn('Could not save email to sessionStorage', e)
  }
}

export function getSignupEmailFromStorage(): string | null {
  try {
    return sessionStorage.getItem(LOGIN_EMAIL_STORAGE_KEY)
  } catch (e) {
    console.warn('Could not get email from sessionStorage', e)

    return null
  }
}

export function clearSignupEmailFromStorage(): void {
  try {
    sessionStorage.removeItem(LOGIN_EMAIL_STORAGE_KEY)
  } catch (e) {
    console.warn('Could not clear email from sessionStorage', e)
  }
}
//#endregion

//#region erpConfigStorage
/**
 * Functions to save/retrieve/clear the erp config in/from sessionStorage.
 * This is used to display the opening hours in the error page when the erp is unavailable.
 * It is returned by the registration error, not reachable by the config, so we use the storage to save it from a page to another.
 */
export type ErpConfig = {
  openingHour?: string
  closingHour?: string
  isClosedOnSaturday?: boolean
  isClosedOnSunday?: boolean
}

export function saveErpConfigToStorage(config: ErpConfig): void {
  try {
    sessionStorage.setItem(ERP_OPENING_HOURS_CONFIG_STORAGE_KEY, JSON.stringify(config))
  } catch (e) {
    console.warn('Could not save ErpConfig to sessionStorage', e)
  }
}

export function getErpConfigFromStorage(): ErpConfig | null {
  try {
    const item = sessionStorage.getItem(ERP_OPENING_HOURS_CONFIG_STORAGE_KEY)

    return item ? JSON.parse(item) : null
  } catch (e) {
    console.warn('Could not get ErpConfig from sessionStorage', e)

    return null
  }
}

export function clearErpConfigFromStorage(): void {
  try {
    sessionStorage.removeItem(ERP_OPENING_HOURS_CONFIG_STORAGE_KEY)
  } catch (e) {
    console.warn('Could not clear ErpConfig from sessionStorage', e)
  }
}
//#endregion
